<div
  class="ui-data-table"
  [class.ui-data-table--virtual]="virtualScroll">
  <div class="ui-data-table__scroll">
    <div class="ui-data-table__track" [style.min-width]="trackMinWidth">
      <table class="ui-data-table__table ui-data-table__table--header">
        <colgroup>
          <col
            *ngFor="let col of columns"
            [style.width]="getColumnWidth(col)"
            [style.min-width]="getColumnMinWidth(col)" />
        </colgroup>
        <thead>
          <tr>
            <th
              *ngFor="let col of columns"
              [style.width]="getColumnWidth(col)"
              [style.min-width]="getColumnMinWidth(col)"
              [class.ui-data-table__th--sortable]="col.sortable"
              [class.ui-data-table__th--checkbox]="col.type === 'checkbox'"
              [class.ui-data-table__th--actions]="col.type === 'actions'"
              (click)="onSort(col)">
              <span class="ui-data-table__th-content" *ngIf="col.type !== 'checkbox'">
                {{ col.label }}
                <mat-icon *ngIf="col.sortable" class="ui-data-table__sort-icon">
                  {{ sortColumn === col.key ? (sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more' }}
                </mat-icon>
              </span>
              <input
                *ngIf="col.type === 'checkbox'"
                type="checkbox"
                [checked]="allSelectableSelected"
                [indeterminate]="someSelectableSelected"
                (click)="$event.stopPropagation()"
                (change)="onSelectAllChange($event)">
            </th>
          </tr>
        </thead>
      </table>

      <ng-container *ngIf="!virtualScroll">
        <table class="ui-data-table__table">
          <colgroup>
            <col
              *ngFor="let col of columns"
              [style.width]="getColumnWidth(col)"
              [style.min-width]="getColumnMinWidth(col)" />
          </colgroup>
          <tbody>
            <tr *ngIf="rows.length === 0">
              <td [attr.colspan]="columns.length" class="ui-data-table__empty">No records found</td>
            </tr>
            <tr *ngFor="let row of rows" (click)="onRowClick(row)">
              <td
                *ngFor="let col of columns"
                [style.width]="getColumnWidth(col)"
                [style.min-width]="getColumnMinWidth(col)"
                [class.ui-data-table__td--checkbox]="col.type === 'checkbox'"
                [class.ui-data-table__td--actions]="col.type === 'actions'"
                [attr.title]="getCellTitle(row, col)">
                <ng-container *ngTemplateOutlet="cellTemplate; context: { row: row, col: col }"></ng-container>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>

      <cdk-virtual-scroll-viewport
        *ngIf="virtualScroll"
        class="ui-data-table__viewport"
        [itemSize]="itemSize"
        [style.height]="resolvedViewportHeight"
        (scrolledIndexChange)="onVirtualScroll()">
        <table class="ui-data-table__table">
          <colgroup>
            <col
              *ngFor="let col of columns"
              [style.width]="getColumnWidth(col)"
              [style.min-width]="getColumnMinWidth(col)" />
          </colgroup>
          <tbody>
            <tr *ngIf="rows.length === 0">
              <td [attr.colspan]="columns.length" class="ui-data-table__empty">No records found</td>
            </tr>
            <tr *cdkVirtualFor="let row of rows" (click)="onRowClick(row)">
              <td
                *ngFor="let col of columns"
                [style.width]="getColumnWidth(col)"
                [style.min-width]="getColumnMinWidth(col)"
                [class.ui-data-table__td--checkbox]="col.type === 'checkbox'"
                [class.ui-data-table__td--actions]="col.type === 'actions'"
                [attr.title]="getCellTitle(row, col)">
                <ng-container *ngTemplateOutlet="cellTemplate; context: { row: row, col: col }"></ng-container>
              </td>
            </tr>
          </tbody>
        </table>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>
</div>

<ng-template #cellTemplate let-row="row" let-col="col">
  <ng-container [ngSwitch]="col.type || 'text'">
    <span *ngSwitchCase="'text'" class="ui-data-table__cell-text">{{ getCellValue(row, col.key) ?? '—' }}</span>

    <a
      *ngSwitchCase="'link'"
      class="ui-data-table__link"
      href="javascript:void(0)"
      [attr.title]="getCellTitle(row, col)"
      (click)="onLinkClick(row, col.key, $event)">
      {{ getCellValue(row, col.key) }}
    </a>

    <app-ui-badge
      *ngSwitchCase="'badge'"
      [label]="getCellValue(row, col.key) + ''"
      [variant]="getBadgeVariant(row, col)">
    </app-ui-badge>

    <span *ngSwitchCase="'date'" class="ui-data-table__cell-text">{{ formatDate(getCellValue(row, col.key)) }}</span>

    <input
      *ngSwitchCase="'checkbox'"
      type="checkbox"
      [checked]="!!row['selected']"
      [disabled]="!!row['selectionDisabled']"
      (click)="$event.stopPropagation()"
      (change)="onCheckboxChange(row, $event)">

    <app-ui-table-actions
      *ngSwitchCase="'actions'"
      [actions]="row['actions'] || []"
      (actionClick)="onActionClick(row, $event.type)">
    </app-ui-table-actions>

    <span *ngSwitchDefault class="ui-data-table__cell-text">{{ getCellValue(row, col.key) ?? '—' }}</span>
  </ng-container>
</ng-template>
